import { AsyncPipe } from "@angular/common";
import {
    Component,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PageComponent } from "@components/page/page.component";
import { TabComponent } from "@components/tabs/tab/tab.component";
import { TabsComponent as TabsComponent_1 , TabsComponent } from "@components/tabs/tabs.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map, share } from "rxjs/operators";

import { CanBeDirty } from "~app/common/guards/dirty.guard";
import { JlpKundorderComponent } from "./tabs/jlp-kundorder/jlp-kundorder.component";
import { JlpLeverantorsorderComponent } from "./tabs/jlp-leverantorsorder/jlp-leverantorsorder.component";
import { JlpProduktionsomradenComponent } from "./tabs/jlp-produktionsomraden/jlp-produktionsomraden.component";

@Component({
    selector: "rask-justera-leveransplan",
    templateUrl: "./justera-leveransplan.component.html",
    styleUrls: ["./justera-leveransplan.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        TabsComponent_1,
        TabComponent,
        JlpKundorderComponent,
        JlpLeverantorsorderComponent,
        JlpProduktionsomradenComponent,
        AsyncPipe,
        TranslatePipe
    ]
})
export class JusteraLeveransplanComponent implements CanBeDirty, OnInit {
    @ViewChild(TabsComponent) viewChild: TabsComponent;

    protected canEdit$: Observable<boolean>;

    private readonly activatedRoute = inject(ActivatedRoute);

    isDirtyFn(): Promise<boolean> {
        return this.viewChild.activeTab.deactivate();
    }

    ngOnInit(): void {
        this.canEdit$ = this.activatedRoute.data.pipe(
            map(data => data.canEdit),
            share()
        );
    }
}
